// src/components/InAppBrowserNotice.jsx
// 인앱 브라우저에서 로그인/가입 시도 시 외부 브라우저로 유도하는 배너.
// 감지 안 되면 아무것도 렌더하지 않음.

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';
import { detectInAppBrowser, openInExternalBrowser } from '../utils/inAppBrowser.js';

export default function InAppBrowserNotice() {
  const { t } = useTranslation();
  const [provider] = useState(() => detectInAppBrowser());
  if (!provider) return null;

  function copyLink() {
    navigator.clipboard?.writeText(window.location.href).then(
      () => toast.success(t('auth.copied')),
      () => toast.error(t('account.copyFailed')),
    );
  }

  return (
    <div className="w-full max-w-md mb-4 rounded-xl border-2 border-amber-300 bg-amber-50 p-3 text-sm text-amber-900 space-y-2">
      <p className="font-bold">⚠ {t('auth.inappTitle')}</p>
      <p className="text-xs leading-relaxed">{t('auth.inappDesc')}</p>
      <div className="flex gap-2">
        <button className="btn-primary !py-1.5 text-xs" onClick={() => { if (!openInExternalBrowser()) copyLink(); }}>
          {t('auth.openExternal')}
        </button>
        <button className="btn-secondary !py-1.5 text-xs" onClick={copyLink}>
          {t('auth.copyLink')}
        </button>
      </div>
    </div>
  );
}
